const swiper = new Swiper(".stories-modal .swiper", {
    pagination: {
      el: ".stories-modal .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".stories-modal .swiper-button-next",
      prevEl: ".stories-modal .swiper-button-prev",
    },
  });
  
  /* STORIES */
  
  const stories = document.querySelector('.stories');
  const storiesStory = stories.querySelectorAll('.story');
  
  const storiesModal = document.querySelector('.stories-modal');
  const storiesModalWrapper = storiesModal.querySelector('.swiper .swiper-wrapper');
  const storiesModalStory = storiesModal.querySelectorAll('.story');
  
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            console.log(`Video ${entry.target.id} : visible`);
        } else {
            console.log(`Video ${entry.target.id} : not visible`);
        }
    });
  });
  
  function openStoriesModal(){
    storiesModal.setAttribute('open', '');
  }
  
  function closeStoriesModal(){
    storiesModal.removeAttribute('open');
  }
  
  function updateStorieModalStory(storyId){
  
    for(let i=0;i<storiesModalStory.length;i++){
      const storyVideo = storiesModalStory[i].querySelector('.video video');
      storyVideo.pause();
      storyVideo.currentTime = 0;
  
      // BUTTONS
      const storyButtons = storiesModalStory[i].querySelectorAll('.story__contols .story__button');
      for(let j=0;j<storyButtons.length;j++){
        if(storyButtons[j].id == 'playback'){
          storyButtons[j].dataset.state = 'break';
        }
      }
  
    }
  
    if(storyId != null){
      const storyVideo = storiesModalStory[storyId-1].querySelector('.video video');
      storyVideo.play();
    }
  }
  
  /* MODAL */
  
  storiesModalStory.forEach((story, index) => {
  
    const progressBar = story.querySelector('.progress-container .progress-bar');
    const storyVideo = story.querySelector('.video video');
    storyVideo.id = index;
  
    // VIDEO
    storyVideo.addEventListener('timeupdate', () => {
      const percentage = (storyVideo.currentTime / storyVideo.duration) * 100;
      progressBar.style.width = percentage + '%';
    });
  
    //BUTTONS
    const storyButtons = story.querySelectorAll('.story__contols .story__button');
    storyButtons.forEach(button => {
      button.addEventListener('click', () => {
        if(button.id == 'close'){
          closeStoriesModal();
          updateStorieModalStory(null);
        }else if(button.id == 'sound'){
          if(button.dataset.state == 'off'){
            storyVideo.muted = false;
            button.dataset.state = 'on';
          }else if(button.dataset.state == 'on'){
            storyVideo.muted = true;
            button.dataset.state = 'off';
          }
        }else if(button.id == 'playback'){
          if(button.dataset.state == 'break'){
            storyVideo.pause();
            button.dataset.state = 'play';
          }else if(button.dataset.state == 'play'){
            storyVideo.play();
            button.dataset.state = 'break';
          }
        }
      })
    })
  
    //observer.observe(video);
  
  })
  
  /* STORY */
  
  storiesStory.forEach(story => {
    story.addEventListener('click', () => {
      
      openStoriesModal();
  
      const storyId = story.id;
      updateStorieModalStory(storyId);
  
      const storyWidth = storiesModalStory[0].clientWidth*(storyId-1);
      setTimeout(function() {
        storiesModalWrapper.style.transform = `translate3d(-${storyWidth}px, 0px, 0px)`;
      }, 100); 
  
    })
  })
  
  /* SLIDE CHANGE */
  
  swiper.on('slideChange', () => {
    updateStorieModalStory(swiper.activeIndex+1);
  });